import request from '@/utils/common_req'
import gateway_request from '@/utils/gateway_req'

const api = {
  // 留言信息查询
  checkLeaveMessage(params) {
    return gateway_request({
      url: '?s=Customer.Messages.Check',
      method: 'GET',
      params: params,
    })
  },
  getMessageType(params) {
    return request({
      url: '?s=Customer.Messages.Types',
      method: 'GET',
      params: params,
    })
  },
  // 提交留言
  sendLeaveMessage(params) {
    return gateway_request({
      url: '?s=Customer.Messages.Send',
      method: 'POST',
      data: params,
    })
  },
  // 获取电话
  getPhone(params) {
    return request({
      url: process.env.VUE_APP_UPLOAD_API + 'index/messages/getPhone',
      method: 'GET',
      params: params,
    })
  },
  // 改变客服消息状态
  setMsgRead(params) {
    return request({
      url: '?s=Customer.UserSession.setMsgRead',
      method: 'GET',
      params: params,
    })
  },
  //提交满意度评价
  saveEvaluateMsg(params) {
    return gateway_request({
      url: '?s=Customer.UserSession.saveSatisfaction',
      method: 'POST',
      data: params,
    })
  },

  // 公告详情
  getAnnounceDetail(data) {
    return request({
      url: '?service=Customer.UserNotice.detail',
      method: 'POST',
      data: data,
    })
  },

  // 公告流量次数
  reportAnnounceCount(data) {
    return request({
      url: '?service=Customer.UserNotice.click',
      method: 'POST',
      data: data,
    })
  },
  // 自助服务页
  getCard(params) {
    return request({
      url: '?s=Customer.ServiceCard.getCard',
      method: 'GET',
      params: params,
    })
  },
  // 获取热门问题
  getHotProblems(params) {
    return request({
      url: '?s=Customer.Web.getHotProblems',
      method: 'GET',
      params: params,
    })
  },
  // 热门问详情
  getHotDetail(params) {
    return request({
      url: '?s=Customer.Web.getHotDetail',
      method: 'GET',
      params: params,
    })
  },
  // 猜你想问  点赞/点踩
  addRobotKnowComment(params) {
    return request({
      url: '?s=Customer.Web.addRobotKnowComment',
      method: 'POST',
      data: params,
    })
  },
  track(params) {
    return request({
      url: process.env.VUE_APP_BASE_API+'?s=Customer.Web.reportUserBuried',
      method: 'POST',
      data: params
    })
  },
  // 自助卡片点击上报
  clickServiceCard(params) {
    return request({
      url: '?s=Customer.ServiceCard.click',
      method: 'POST',
      data: params,
    })
  },

  // 获取ETC链接 s=Customer.Web.getEtcUrl
  getEtcUrl(params) {
    return request({
      url: '?s=Customer.Web.getEtcUrl',
      method: 'POST',
      data: params,
    })
  },
}

export default api
